import React from 'react';
import { Combobox } from '@headlessui/react';
import { ComboboxErrorHintLabel } from './ComboboxErrorHintLabel';
import classNames from 'classnames';
import { Show } from '../../../../components/shared/Show';

export const ComboboxFormCell: React.FC<{
  labelText?: string;
  errorText?: string;
  hintText?: string;
  isRequired?: boolean;
  children?: React.ReactNode;
}> = ({ isRequired, labelText, errorText, hintText, children }) => {
  const comboLabelText = `${labelText}${isRequired ? ' *' : ''}`;
  return (
    <div className="pb-2">
      <Show when={!!labelText}>
        <Combobox.Label
          className={classNames('block whitespace-pre-line text-xs', {
            'text-red-700': !!errorText,
            'text-neutral-900': !errorText,
          })}
        >
          {comboLabelText}
        </Combobox.Label>
      </Show>
      <div className="relative">{children}</div>
      <ComboboxErrorHintLabel errorText={errorText} hintText={hintText} />
    </div>
  );
};
